<template>
  <div id="nav">
    <el-menu router
             class="el-menu-vertical-demo"
             :default-active="onRoute"
             text-color="black"
             unique-opened
             :collapse="isCollapse"
             @select="select">
      <el-menu-item @click="isCollapse = !isCollapse">
        <i :class="{'el-icon-back':!isCollapse,'el-icon-right':isCollapse}"
           v-show="isCollapse"></i>
        <div slot="title">
          <img src="../assets/img/logo_black.png"
               style="width: 159px;"
               alt="">
        </div>
      </el-menu-item>
      <template v-for="item in menuList">
        <el-submenu :index="item.actionUrl"
                    :key="item.id"
                    v-if="item.children && item.children.length > 0">
          <template slot="title">
            <img style="width: 17px"
                 :src="imagePath(item.selectedIconPath)"
                 v-if="item.selectedIconPath"
                 alt="" />
            <i v-else
               :class="item.iconClass"
               :style="{ color: `${item.iconColor}` }"></i>
            <span slot="title"> {{ item.menuName }}</span>

          </template>
          <template v-for="menu in item.children">
            <el-submenu :index="menu.actionUrl"
                        :key="menu.id"
                        v-if="menu.children && menu.children.length > 0"
                        class="Thirdlevel">
              <template slot="title">
                {{ menu.menuName }}
              </template>
              <el-menu-item class="active-menu"
                            v-for="childmenu in menu.children"
                            :key="childmenu.id"
                            :index="'/' + childmenu.actionUrl">
                {{ childmenu.menuName }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item class="active-menu"
                          v-else
                          v-show="menu.auth && ($globalData.flag || (menu.id != 2266 && menu.id != 2267 && menu.id != 2268))"
                          :key="menu.actionUrl"
                          :index="'/' + menu.actionUrl">
              {{ menu.menuName }}
            </el-menu-item>
          </template>
        </el-submenu>

        <el-menu-item v-if="item.children ==null || item.children.length == 0 && item.auth"
                      :index="'/' + item.actionUrl"
                      :key="item.actionUrl"
                      @click="handle">
          <img style="width: 17px"
               :src="imagePath(item.selectedIconPath)"
               v-if="item.selectedIconPath"
               alt="" />
          <i v-else
             :class="item.iconClass"
             :style="{ color: `${item.iconColor}`, marginRight: '0px' }"></i>
          <span slot="title"> {{ item.menuName }}</span>

        </el-menu-item>
      </template>
      <!-- <div class="open-menu"
           @click="isCollapse = !isCollapse">
        <i :class="{'el-icon-s-fold':!isCollapse,'el-icon-s-unfold':isCollapse}"></i>

      </div> -->
    </el-menu>

    <!-- <el-menu :router="true" :default-active="onRoute">
      <el-menu-item
        :index="'/' + item.actionUrl"
        v-for="item in menuList"
        :key="item.id"
      >
        {{ item.menuName }}
      </el-menu-item>
    </el-menu> -->
  </div>
</template>

<script>
import marqueeLeft from "@/components/Announcement";
export default {
  components: {
    marqueeLeft,
  },
  props: {
    menuList: Array,
  },
  data () {
    return {
      route: this.$route,
      isCollapse: false,
    };
  },
  created () { },
  mounted () {
    console.log(this.menuList);
  },
  computed: {
    onRoute () {
      if (this.route.meta.activeMenu) return this.route.meta.activeMenu;
      return this.route.path;
    },
  },
  methods: {
    handle () {

    },
    imagePath (name) {
      if (name) {
        return require(`../assets/img/nav/${name}`);
      }
    },
    select (val) {
      // console.log(val);
      return;
    },
  },
  watch: {
    $route (val) {
      this.route = val;
    },
  },
};
</script>

<style lang="less">
.el-menu-vertical-demo {
  height: 100%;
  position: relative;
}
.open-menu {
  position: absolute;
  top: calc(50% - 15px);
  right: -32px;
  background-color: #c0c4cc;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  border-radius: 0 5px 5px 0;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  height: 100%;
}
#nav {
  .announcement {
    float: right;
    width: 200px;
    height: 30px;
  }

  //nav一级菜单的通用样式
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 36px !important;
    line-height: 36px !important;
    padding: 0 8px;
    font-size: 15px;
  }
  .el-menu--horizontal > .el-menu-item {
    height: 36px !important;
    line-height: 36px !important;
    padding: 0 8px;
    font-size: 15px;
  }

  //nav一级菜单激活的样式
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    // background-color: #6c9ffe !important;
    // color: white !important;
  }

  .el-menu.el-menu--horizontal {
    // border-bottom: solid 1px black;
  }
}
//nav激活的图标样式
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title i {
  // color: white !important;
}
//nav二级菜单激活的样式
.el-menu-item.active-menu.is-active {
  // background-color: #6c9ffe !important;
  // color: white !important;
}
.el-menu--horizontal .el-menu .el-menu-item {
  background-color: #4e89f7;
  color: #fff !important;
}
.el-menu--popup-bottom-start {
  margin-top: 0;
  background-color: #4e89f7;
}
.el-menu--popup {
  border-radius: 0 0 10px 10px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  // background-color: #6c9ffe !important;

  // color: white !important;
}
.Thirdlevel .el-submenu__title {
  background-color: transparent !important;
  color: white !important;
  i {
    color: white;
  }
}
</style>
